import * as React from 'react';
import {AnalyticsContext} from './createAnalyticsContext';

export const createAnalyticsConsumer = <T extends string>(
  context: React.Context<AnalyticsContext<T>>,
) => {
  return context.Consumer;
};
